export default __webpack_public_path__ + "static/media/home_ghibli_totoro.6cc60570.jpg";